export default {
    data() {
        return {
            loadTable: false,
        }
    },
    created() {
        this.fetchData();
    },
}
